import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Modal,
  Form,
} from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const NewCourseModal = ({contextPk, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const [courseNum, updateCourseNum] = useState('')
  const [errorText, updateErrorText] = useState(null)

  const handleCourseNumChange = e => {
    updateCourseNum(e.target.value)
  }

  const AddNewCourse = () => {
    const fetchData = async () => {
      try {
        await client.post(endpoints.addNewCourse({ contextPk: contextPk }), {
          courseNum: courseNum,
        })
        toast.success("Successfully added new course.")
        // Trigger the lower components useEffect hook
        dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
        toggle(!show)
        updateCourseNum('')
        updateErrorText(null)
      } catch(err) {
        if (err.response.status === 500) {
          console.log('error: ', err.response)
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          updateErrorText(err.response.data.error)
        }
      }
    }
    fetchData()
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Course Mapping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <Form.Group controlId="contextId">
          <Form.Label>Coursenum:</Form.Label>
          <Form.Control
            type="text"
            onChange={handleCourseNumChange}
            value={courseNum}
          />
        </Form.Group>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => AddNewCourse()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Link Course
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewCourseModal.propTypes = {
  contextPk: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default NewCourseModal
